import React from "react";
import { Box, Chip, Stack, Typography } from "@mui/material";
import { insetSx, surfaceSx } from "../center/ownerCenterUi";
import { minutesLabel } from "./ownerProjectUi";
import OwnerProjectStepsPanel from "./OwnerProjectStepsPanel";

export default function OwnerProjectWorkPanel({ steps, workPlan, meetings = [], onNewActivity, onCreateSteps, onReorderSteps, onDeleteStep, onTime, onDone, onEdit, onState }) {
  const plan = workPlan || {};
  const pending = (steps?.items || []).filter((row) => row.status === "open");
  const contextOnly = pending.filter((row) => ["objective", "idea", "note"].includes(row.projectItemType || "action")).length;
  const executable = Number(plan.executableCount || 0);
  const waiting = Number(plan.waitingCount || 0);
  const blockers = Number(plan.blockerCount || 0) + Number(plan.dependencyBlockedCount || 0);

  return <Box sx={{ ...surfaceSx, p: { xs: 1.2, md: 1.45 } }}>
    <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" spacing={.7} alignItems={{ sm: "center" }}>
      <Box>
        <Typography sx={{ fontWeight: 1000, fontSize: "1rem" }}>Pendientes</Typography>
        <Typography sx={{ mt: .1, color: "text.secondary", fontSize: ".7rem" }}>Acá vive el mapa del proyecto. Today toma sólo las acciones realmente ejecutables.</Typography>
      </Box>
      <Stack direction="row" spacing={.35} useFlexGap flexWrap="wrap">
        <Chip size="small" variant="outlined" label={`${executable} listos`} />
        {waiting ? <Chip size="small" color="warning" variant="outlined" label={`${waiting} esperando`} /> : null}
        {blockers ? <Chip size="small" color="error" variant="outlined" label={`${blockers} trabas`} /> : null}
        {contextOnly ? <Chip size="small" variant="outlined" label={`${contextOnly} contexto`} /> : null}
      </Stack>
    </Stack>

    {plan.next ? <Box sx={{ ...insetSx, mt: .8, px: .9, py: .7 }}>
      <Stack direction={{ xs: "column", sm: "row" }} justifyContent="space-between" spacing={.4}>
        <Box><Typography sx={{ color: "text.secondary", fontSize: ".61rem", fontWeight: 950 }}>PRÓXIMA ACCIÓN EJECUTABLE</Typography><Typography sx={{ mt: .12, fontWeight: 950, fontSize: ".8rem" }}>{plan.next.title}</Typography></Box>
        {plan.next.estimatedMinutes ? <Typography sx={{ color: "text.secondary", fontSize: ".68rem", whiteSpace: "nowrap" }}>≈ {minutesLabel(plan.next.estimatedMinutes)}</Typography> : null}
      </Stack>
    </Box> : null}

    <OwnerProjectStepsPanel
      steps={steps}
      onCreateSteps={onCreateSteps}
      onReorderSteps={onReorderSteps}
      onDeleteStep={onDeleteStep}
      onEdit={onEdit}
      onDone={onDone}
      onState={onState}
      onTime={onTime}
      onNewActivity={onNewActivity}
    />

    {meetings?.length ? <Typography sx={{ mt: .7, color: "text.secondary", fontSize: ".65rem" }}>{meetings.length} reunión(es) próximas siguen visibles en agenda; podés anotarlas también como “Reunión” para que formen parte del mapa.</Typography> : null}
  </Box>;
}
